import { render, staticRenderFns } from "./devicesTable.vue?vue&type=template&id=0c004e4a&scoped=true&"
import script from "./devicesTable.vue?vue&type=script&lang=js&"
export * from "./devicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c004e4a",
  null
  
)

export default component.exports